<template>

  <header class="flex flex-col items-center justify-center bg-cover"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    <div class="flex flex-col items-center gap-6 my-10">
      <img class="object-contain w-1/2" src="@/assets/logo.png" />
      

    </div>
  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>